import { lazy } from 'react'
import {
  ADD_SCENES_ROUTE,
  ADD_VOUCHERS_ROUTE,
  ADMIN_ROUTE,
  COVERS_ROUTE,
  EDIT_SCENES_ROUTE,
  EDIT_VOUCHERS_ROUTE,
  MAIN_ROUTE,
  ORDERS_ROUTE,
  ORDER_ROUTE,
  SCENES_ROUTE,
  STATS_ROUTE,
  VOUCHERS_ROUTE,
  GIFT_VOUCHERS_ROUTE,
  FAQ_ROUTE,
  DELIVERY_ROUTE,
  CONTACTS_ROUTE,
  WARRANTY_ROUTE,
  POLICY_ROUTE,
  THANKS_ROUTE, DIGITAL_ORDERS_ROUTE, GREETING_ROUTE, USERS_ROUTE, ADD_COVERS_ROUTE, EDIT_COVERS_ROUTE,
  PREDEFINED_BOOKS_ROUTE, EDIT_PREDEFINED_BOOK_ROUTE, PREVIEW_BOOK_ROUTE
} from "./consts"

// Lazy-loaded per route so the homepage bundle no longer ships the whole app (order builder,
// admin panels, face-parts engine). Each route's code is fetched on demand; <Suspense> in
// AppRouter shows a loader while a chunk downloads.
const Index = lazy(() => import('./../pages/site/Index'))
const Dashboard = lazy(() => import('./../pages/admin/Dashboard'))
const Order = lazy(() => import('../pages/site/Order/Order'))
const Scenes = lazy(() => import('../pages/admin/Scenes'))
const Orders = lazy(() => import('./../pages/admin/Orders'))
const EditOrderBook = lazy(() => import('../pages/admin/EditOrderBook'))
const Stats = lazy(() => import('./../pages/admin/Stats'))
const Scene = lazy(() => import('../pages/admin/Scene'))
const ProcessOrder = lazy(() => import('../pages/admin/ProcessOrder'))
const Vouchers = lazy(() => import('../pages/admin/Vouchers'))
const Voucher = lazy(() => import('../pages/admin/Voucher'))
const GiftVouchers = lazy(() => import('../pages/admin/GiftVouchers'))
const Covers = lazy(() => import('../pages/admin/Covers'))
const Faq = lazy(() => import('../pages/site/Faq'))
const Contacts = lazy(() => import('./../pages/site/Contacts'))
const Delivery = lazy(() => import('./../pages/site/Delivery'))
const Warranty = lazy(() => import('./../pages/site/Warranty'))
const PrivacyPolicy = lazy(() => import('../pages/site/PrivacyPolicy'))
const Thanks = lazy(() => import('../pages/Thanks'))
const DigitalOrders = lazy(() => import('../pages/admin/DigitalOrders'))
const ProcessDigitalOrder = lazy(() => import('../pages/admin/ProcessDigitalOrder'))
const Greeting = lazy(() => import('../pages/Greeting'))
const BookPreview = lazy(() => import('../pages/BookPreview'))
const Users = lazy(() => import('../pages/admin/Users'))
const Cover = lazy(() => import('../pages/admin/Cover'))
const PredefinedBooks = lazy(() => import('../pages/admin/PredefinedBooks'))
const PredefinedBook = lazy(() => import('../pages/admin/PredefinedBook'))


export const authRoutes = [
  {
    path: ADMIN_ROUTE,
    Component: Dashboard
  },
  {
    path: SCENES_ROUTE,
    Component: Scenes
  },
  {
    path: ADD_SCENES_ROUTE,
    Component: Scene
  },
  {
    path: EDIT_SCENES_ROUTE+"/:id",
    Component: Scene
  },
  {
    path: STATS_ROUTE,
    Component: Stats
  },
  {
    path: ORDERS_ROUTE,
    Component: Orders
  },
  {
    path: DIGITAL_ORDERS_ROUTE,
    Component: DigitalOrders
  },
  {
    path: ORDERS_ROUTE+"/edit/:id",
    Component: EditOrderBook
  },
  {
    path: ORDERS_ROUTE+"/:id",
    Component: ProcessOrder
  },
  {
    path: DIGITAL_ORDERS_ROUTE+"/:id",
    Component: ProcessDigitalOrder
  },
  {
    path: VOUCHERS_ROUTE,
    Component: Vouchers
  },
  {
    path: ADD_VOUCHERS_ROUTE,
    Component: Voucher
  },
  {
    path: EDIT_VOUCHERS_ROUTE+"/:code",
    Component: Voucher
  },
  {
    path: GIFT_VOUCHERS_ROUTE,
    Component: GiftVouchers
  },
  {
    path: COVERS_ROUTE,
    Component: Covers
  },
  {
    path: ADD_COVERS_ROUTE,
    Component: Cover
  },
  {
    path: EDIT_COVERS_ROUTE+"/:id",
    Component: Cover
  },
  {
    path: USERS_ROUTE,
    Component: Users
  },
  {
    path: PREDEFINED_BOOKS_ROUTE,
    Component: PredefinedBooks
  },
  {
    path: EDIT_PREDEFINED_BOOK_ROUTE+"/:id",
    Component: PredefinedBook
  }
]

export const publicRoutes = [
  {
    path: MAIN_ROUTE,
    Component: Index
  },
  {
    path: ORDER_ROUTE,
    Component: Order
  },
  {
    path: THANKS_ROUTE,
    Component: Thanks
  },
  {
    path: FAQ_ROUTE,
    Component: Faq
  },
  {
    path: DELIVERY_ROUTE,
    Component: Delivery
  },
  {
    path: CONTACTS_ROUTE,
    Component: Contacts
  },
  {
    path: WARRANTY_ROUTE,
    Component: Warranty
  },
  {
    path: GREETING_ROUTE+"/:id",
    Component: Greeting
  },
  {
    path: PREVIEW_BOOK_ROUTE+"/:id",
    Component: BookPreview
  },
  {
    path: POLICY_ROUTE,
    Component: PrivacyPolicy
  }
]
